import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';
import EventHandler from '../../../../utils/dom/event-handler';
import { EDIT_CARD_INFO_REMOVED_EVENT } from '../../../../webComponents/EditCardInfo';

class VenueTeamFreeParkTennisAdministrator extends VenueRegistrationFormModal {
	constructor() {
		super({
			wrapperSelector: '.p-team-information',
			sectionWrapperSelector: '.p-team-information-wrapper',
			modalSelector: '#js-venue-team-free-park-tennis-administrator-form-modal',
			triggerSelectors: ['.js-venue-team-add-free-park-tennis-administrator'],
			editTriggerSelectors: ['.js-venue-team-edit-free-park-tennis-administrator'],
			stepsEndpointAttr: 'free-park-tennis-administrator-steps-endpoint',
			submitEndpointAttr: 'free-park-tennis-administrator-submit-endpoint',
			logPrefix: 'VenueTeamFreeParkTennisAdministrator'
		});
	}

	init() {
		super.init();
		if (!this._wrapper) {
			return;
		}

		EventHandler.on(this._wrapper, EDIT_CARD_INFO_REMOVED_EVENT, () => {
			window.location.reload();
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: false,
			exitButtonClasses: 'lta-form-generator__form-exit-button--underlined',
			nextStepButtonLabel: 'Save and continue',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue'
			}
		};
	}
}

VenueRegistrationFormModal.boot(VenueTeamFreeParkTennisAdministrator);

export default VenueTeamFreeParkTennisAdministrator;
